import * as http from '@/utils/http'
import qs from 'qs'
// 登录
export const login = ({ userName, passWord }) => {return http.post('/token',qs.stringify({UserName: userName,PassWord: passWord,grant_type: 'password'}))};
//获取权限表
export const getUserRightList = params => { return http.get(`/Api/UserRight/GetUserRightList`,params).then(res => res); };
//获取角色列表
export const getRoleList = params => { return http.get(`/Api/UserRight/GetRoleList`,params).then(res => res); };
//查询所有权限
export const getRightList = params => { return http.get(`/Api/UserRight/GetRightList`,params).then(res => res); };
//获取用户组
export const getRoleRightList = params => { return http.get(`/Api/UserRight/GetRoleRightList`,params).then(res => res); };
//插入角色
export const insertRole = params => { return http.post (`/Api/UserRight/InsertRole`,params).then(res => res); };
//修改角色
export const updateRole = params => { return http.post (`/Api/UserRight/UpdateRole`,params).then(res => res); };
//删除角色
export const deleteRole = params => { return http.get(`/Api/UserRight/DeleteRole`,params).then(res => res); };
//添加角色权限
export const insertRoleRights = params => { return http.post(`/Api/UserRight/InsertRoleRights`,params).then(res => res); };
//查询用户列表
export const getUserList = params => { return http.get(`/Api/User/GetUserList`,params).then(res => res); };
//修改用户
export const updateUser = params => { return http.post(`/Api/User/UpdateUser`,params).then(res => res); };
//新增用户
export const insertUser = params => { return http.post(`/Api/User/InsertUser`,params).then(res => res); };
//删除用户
export const deleteUser = params => { return http.post(`/Api/User/DeleteUser`,params).then(res => res); };
//修改用户密码
export const updateUserPwd = params => { return http.post(`/Api/User/UpdateUserPwd`,params).then(res => res); };
//重置密码
export const resetPassword = params => { return http.post(`/Api/User/ResetPassword`,params).then(res => res); };
//获取基础数据
export const getBaseDataList = params => { return http.get(`/Api/BaseData/GetBaseDataList`,params).then(res => res); };
//获取基础数据类型
export const getBaseDataTypeList = params => { return http.get(`/Api/BaseData/GetBaseDataTypeList`,params).then(res => res); };
//获取基础数据
export const getBaseDataListView = params => { return http.get(`/Api/BaseData/GetBaseDataListView`,params).then(res => res); };
//修改基础数据
export const updateByModelsBaseData = params => { return http.post(`/Api/BaseData/UpdateByModels `,params).then(res => res); };
//新增基础数据
export const insertByModelsBaseData = params => { return http.post(`/Api/BaseData/InsertByModels`,params).then(res => res); };
//删除基础数据
export const deleteByIdsBaseData = params => { return http.post(`/Api/BaseData/DeleteByIds`,params).then(res => res); };
//获取机构信息列表
export const getOrgInfoList = params => { return http.get(`/Api/User/GetOrgInfoList`,params).then(res => res); };

///------------------------------有机协会
///查询协会介绍信息
export const getXiehuijieshaoList = params => { return http.get(`/Api/Xiehuijieshao/GetList`,params).then(res => res); };
///批量添加协会介绍信息
export const insertByModelsXiehuijieshao = params => { return http.post (`/Api/Xiehuijieshao/InsertByModels`,params).then(res => res); };
///批量修改协会介绍信息
export const updateByModelsXiehuijieshao = params => { return http.post (`/Api/Xiehuijieshao/UpdateByModels`,params).then(res => res); };
///批量删除协会介绍信息
export const deleteByIdsXiehuijieshao = params => { return http.post (`/Api/Xiehuijieshao/DeleteByIds`,params).then(res => res); };
///查询协会介绍信息分页
export const getXiehuijieshaoListView = params => { return http.get (`/Api/Xiehuijieshao/GetListView`,params).then(res => res); };
///查询协会章程信息
export const getXiehuizhangchengList = params => { return http.get(`/Api/Xiehuizhangcheng/GetList`,params).then(res => res); };
///批量添加协会章程信息
export const insertByModelsXiehuizhangcheng = params => { return http.post (`/Api/Xiehuizhangcheng/InsertByModels`,params).then(res => res); };
///批量修改协会章程信息
export const updateByModelsXiehuizhangcheng = params => { return http.post (`/Api/Xiehuizhangcheng/UpdateByModels`,params).then(res => res); };
///批量删除协会章程信息
export const deleteByIdsXiehuizhangcheng = params => { return http.post (`/Api/Xiehuizhangcheng/DeleteByIds`,params).then(res => res); };
///查询协会章程信息分页
export const getXiehuizhangchengListView = params => { return http.get (`/Api/Xiehuizhangcheng/GetListView`,params).then(res => res); };
///查询组织架构信息
export const getZuzhijiagouList = params => { return http.get(`/Api/Zuzhijiagou/GetList`,params).then(res => res); };
///批量添加组织架构信息
export const insertByModelsZuzhijiagou = params => { return http.post (`/Api/Zuzhijiagou/InsertByModels`,params).then(res => res); };
///批量修改组织架构信息
export const updateByModelsZuzhijiagou = params => { return http.post (`/Api/Zuzhijiagou/UpdateByModels`,params).then(res => res); };
///批量删除组织架构信息
export const deleteByIdsZuzhijiagou = params => { return http.post (`/Api/Zuzhijiagou/DeleteByIds`,params).then(res => res); };
///查询组织架构信息分页
export const getZuzhijiagouListView = params => { return http.get (`/Api/Zuzhijiagou/GetListView`,params).then(res => res); };
///查询大事记信息
export const getDashijiList = params => { return http.get(`/Api/Dashiji/GetList`,params).then(res => res); };
///批量添加大事记信息
export const insertByModelsDashiji = params => { return http.post (`/Api/Dashiji/InsertByModels`,params).then(res => res); };
///批量修改大事记信息
export const updateByModelsDashiji = params => { return http.post (`/Api/Dashiji/UpdateByModels`,params).then(res => res); };
///批量删除大事记信息
export const deleteByIdsDashiji = params => { return http.post (`/Api/Dashiji/DeleteByIds`,params).then(res => res); };
///查询大事记信息分页
export const getDashijiListView = params => { return http.get (`/Api/Dashiji/GetListView`,params).then(res => res); };

///------------------------------新闻资讯
///查询行业动态信息
export const getHangyedongtaiList = params => { return http.get(`/Api/Hangyedongtai/GetList`,params).then(res => res); };
///批量添加行业动态信息
export const insertByModelsHangyedongtai = params => { return http.post (`/Api/Hangyedongtai/InsertByModels`,params).then(res => res); };
///批量修改行业动态信息
export const updateByModelsHangyedongtai = params => { return http.post (`/Api/Hangyedongtai/UpdateByModels`,params).then(res => res); };
///批量删除行业动态信息
export const deleteByIdsHangyedongtai = params => { return http.post (`/Api/Hangyedongtai/DeleteByIds`,params).then(res => res); };
///查询行业动态信息分页
export const getHangyedongtaiListView = params => { return http.get (`/Api/Hangyedongtai/GetListView`,params).then(res => res); };
///查询通知公告信息
export const getTongzhigonggaoList = params => { return http.get(`/Api/Tongzhigonggao/GetList`,params).then(res => res); };
///批量添加通知公告信息
export const insertByModelsTongzhigonggao = params => { return http.post (`/Api/Tongzhigonggao/InsertByModels`,params).then(res => res); };
///批量修改通知公告信息
export const updateByModelsTongzhigonggao = params => { return http.post (`/Api/Tongzhigonggao/UpdateByModels`,params).then(res => res); };
///批量删除通知公告信息
export const deleteByIdsTongzhigonggao = params => { return http.post (`/Api/Tongzhigonggao/DeleteByIds`,params).then(res => res); };
///查询通知公告信息分页
export const getTongzhigonggaoListView = params => { return http.get (`/Api/Tongzhigonggao/GetListView`,params).then(res => res); };
///查询展会信息信息
export const getZhanhuixinxiList = params => { return http.get(`/Api/Zhanhuixinxi/GetList`,params).then(res => res); };
///批量添加展会信息信息
export const insertByModelsZhanhuixinxi = params => { return http.post (`/Api/Zhanhuixinxi/InsertByModels`,params).then(res => res); };
///批量修改展会信息信息
export const updateByModelsZhanhuixinxi = params => { return http.post (`/Api/Zhanhuixinxi/UpdateByModels`,params).then(res => res); };
///批量删除展会信息信息
export const deleteByIdsZhanhuixinxi = params => { return http.post (`/Api/Zhanhuixinxi/DeleteByIds`,params).then(res => res); };
///查询展会信息信息分页
export const getZhanhuixinxiListView = params => { return http.get (`/Api/Zhanhuixinxi/GetListView`,params).then(res => res); };
///查询会员动态信息
export const getHuiyuandongtaiList = params => { return http.get(`/Api/Huiyuandongtai/GetList`,params).then(res => res); };
///批量添加会员动态信息
export const insertByModelsHuiyuandongtai = params => { return http.post (`/Api/Huiyuandongtai/InsertByModels`,params).then(res => res); };
///批量修改会员动态信息
export const updateByModelsHuiyuandongtai = params => { return http.post (`/Api/Huiyuandongtai/UpdateByModels`,params).then(res => res); };
///批量删除会员动态信息
export const deleteByIdsHuiyuandongtai = params => { return http.post (`/Api/Huiyuandongtai/DeleteByIds`,params).then(res => res); };
///查询会员动态信息分页
export const getHuiyuandongtaiListView = params => { return http.get (`/Api/Huiyuandongtai/GetListView`,params).then(res => res); };

///------------------------------政策法规
///查询行业文件信息
export const getHangyewenjianList = params => { return http.get(`/Api/Hangyewenjian/GetList`,params).then(res => res); };
///批量添加行业文件信息
export const insertByModelsHangyewenjian = params => { return http.post (`/Api/Hangyewenjian/InsertByModels`,params).then(res => res); };
///批量修改行业文件信息
export const updateByModelsHangyewenjian = params => { return http.post (`/Api/Hangyewenjian/UpdateByModels`,params).then(res => res); };
///批量删除行业文件信息
export const deleteByIdsHangyewenjian = params => { return http.post (`/Api/Hangyewenjian/DeleteByIds`,params).then(res => res); };
///查询行业文件信息分页
export const getHangyewenjianListView = params => { return http.get (`/Api/Hangyewenjian/GetListView`,params).then(res => res); };
///下载行业文档
export const downloadHangyewenjian = params => { return http.getblob (`/Api/Hangyewenjian/Download`,params).then(res => res); };
///查询行业政策信息
export const getHangyezhengceList = params => { return http.get(`/Api/Hangyezhengce/GetList`,params).then(res => res); };
///批量添加行业政策信息
export const insertByModelsHangyezhengce = params => { return http.post (`/Api/Hangyezhengce/InsertByModels`,params).then(res => res); };
///批量修改行业政策信息
export const updateByModelsHangyezhengce = params => { return http.post (`/Api/Hangyezhengce/UpdateByModels`,params).then(res => res); };
///批量删除行业政策信息
export const deleteByIdsHangyezhengce = params => { return http.post (`/Api/Hangyezhengce/DeleteByIds`,params).then(res => res); };
///查询行业政策信息分页
export const getHangyezhengceListView = params => { return http.get (`/Api/Hangyezhengce/GetListView`,params).then(res => res); };
///查询协会标准信息
export const getXiehuibiaozhunList = params => { return http.get(`/Api/Xiehuibiaozhun/GetList`,params).then(res => res); };
///批量添加协会标准信息
export const insertByModelsXiehuibiaozhun = params => { return http.post (`/Api/Xiehuibiaozhun/InsertByModels`,params).then(res => res); };
///批量修改协会标准信息
export const updateByModelsXiehuibiaozhun = params => { return http.post (`/Api/Xiehuibiaozhun/UpdateByModels`,params).then(res => res); };
///批量删除协会标准信息
export const deleteByIdsXiehuibiaozhun = params => { return http.post (`/Api/Xiehuibiaozhun/DeleteByIds`,params).then(res => res); };
///查询协会标准信息分页
export const getXiehuibiaozhunListView = params => { return http.get (`/Api/Xiehuibiaozhun/GetListView`,params).then(res => res); };

///------------------------------企业风采
///查询会员风采信息
export const getHuiyuanfengcaiList = params => { return http.get(`/Api/Huiyuanfengcai/GetList`,params).then(res => res); };
///批量添加会员风采信息
export const insertByModelsHuiyuanfengcai = params => { return http.post (`/Api/Huiyuanfengcai/InsertByModels`,params).then(res => res); };
///批量修改会员风采信息
export const updateByModelsHuiyuanfengcai = params => { return http.post (`/Api/Huiyuanfengcai/UpdateByModels`,params).then(res => res); };
///批量删除会员风采信息
export const deleteByIdsHuiyuanfengcai = params => { return http.post (`/Api/Huiyuanfengcai/DeleteByIds`,params).then(res => res); };
///查询会员风采信息分页
export const getHuiyuanfengcaiListView = params => { return http.get (`/Api/Huiyuanfengcai/GetListView`,params).then(res => res); };
///查询产品简介信息
export const getChanpinjianjieList = params => { return http.get(`/Api/Chanpinjianjie/GetList`,params).then(res => res); };
///批量添加产品简介信息
export const insertByModelsChanpinjianjie = params => { return http.post (`/Api/Chanpinjianjie/InsertByModels`,params).then(res => res); };
///批量修改产品简介信息
export const updateByModelsChanpinjianjie = params => { return http.post (`/Api/Chanpinjianjie/UpdateByModels`,params).then(res => res); };
///批量删除产品简介信息
export const deleteByIdsChanpinjianjie = params => { return http.post (`/Api/Chanpinjianjie/DeleteByIds`,params).then(res => res); };
///查询产品简介信息分页
export const getChanpinjianjieListView = params => { return http.get (`/Api/Chanpinjianjie/GetListView`,params).then(res => res); };
///查询企业基地信息
export const getQiyejidiList = params => { return http.get(`/Api/Qiyejidi/GetList`,params).then(res => res); };
///批量添加企业基地信息
export const insertByModelsQiyejidi = params => { return http.post (`/Api/Qiyejidi/InsertByModels`,params).then(res => res); };
///批量修改企业基地信息
export const updateByModelsQiyejidi = params => { return http.post (`/Api/Qiyejidi/UpdateByModels`,params).then(res => res); };
///批量删除企业基地信息
export const deleteByIdsQiyejidi = params => { return http.post (`/Api/Qiyejidi/DeleteByIds`,params).then(res => res); };
///查询企业基地信息分页
export const getQiyejidiListView = params => { return http.get (`/Api/Qiyejidi/GetListView`,params).then(res => res); };

///------------------------------其他
///查询会员申请信息
export const getHuiyuanshenqingList = params => { return http.get(`/Api/Huiyuanshenqing/GetList`,params).then(res => res); };
///批量添加会员申请信息
export const insertByModelsHuiyuanshenqing = params => { return http.post (`/Api/Huiyuanshenqing/InsertByModels`,params).then(res => res); };
///批量修改会员申请信息
export const updateByModelsHuiyuanshenqing = params => { return http.post (`/Api/Huiyuanshenqing/UpdateByModels`,params).then(res => res); };
///批量删除会员申请信息
export const deleteByIdsHuiyuanshenqing = params => { return http.post (`/Api/Huiyuanshenqing/DeleteByIds`,params).then(res => res); };
///查询会员申请信息分页
export const getHuiyuanshenqingListView = params => { return http.get (`/Api/Huiyuanshenqing/GetListView`,params).then(res => res); };
///查询文件下载信息
export const getWenjianxiazaiList = params => { return http.get(`/Api/Wenjianxiazai/GetList`,params).then(res => res); };
///批量添加文件下载信息
export const insertByModelsWenjianxiazai = params => { return http.post (`/Api/Wenjianxiazai/InsertByModels`,params).then(res => res); };
///批量修改文件下载信息
export const updateByModelsWenjianxiazai = params => { return http.post (`/Api/Wenjianxiazai/UpdateByModels`,params).then(res => res); };
///批量删除文件下载信息
export const deleteByIdsWenjianxiazai = params => { return http.post (`/Api/Wenjianxiazai/DeleteByIds`,params).then(res => res); };
///查询文件下载信息分页
export const getWenjianxiazaiListView = params => { return http.get (`/Api/Wenjianxiazai/GetListView`,params).then(res => res); };
///下载文件
export const downloadWenjianxiazai = params => { return http.getblob (`/Api/Wenjianxiazai/Download`,params).then(res => res); };
///查询联系我们信息
export const getLianxiwomenList = params => { return http.get(`/Api/Lianxiwomen/GetList`,params).then(res => res); };
///批量添加联系我们信息
export const insertByModelsLianxiwomen = params => { return http.post (`/Api/Lianxiwomen/InsertByModels`,params).then(res => res); };
///批量修改联系我们信息
export const updateByModelsLianxiwomen = params => { return http.post (`/Api/Lianxiwomen/UpdateByModels`,params).then(res => res); };
///批量删除联系我们信息
export const deleteByIdsLianxiwomen = params => { return http.post (`/Api/Lianxiwomen/DeleteByIds`,params).then(res => res); };
///查询联系我们信息分页
export const getLianxiwomenListView = params => { return http.get (`/Api/Lianxiwomen/GetListView`,params).then(res => res); };
///查询有机知识信息
export const getYoujizhishiList = params => { return http.get(`/Api/Youjizhishi/GetList`,params).then(res => res); };
///批量添加有机知识信息
export const insertByModelsYoujizhishi = params => { return http.post (`/Api/Youjizhishi/InsertByModels`,params).then(res => res); };
///批量修改有机知识信息
export const updateByModelsYoujizhishi = params => { return http.post (`/Api/Youjizhishi/UpdateByModels`,params).then(res => res); };
///批量删除有机知识信息
export const deleteByIdsYoujizhishi = params => { return http.post (`/Api/Youjizhishi/DeleteByIds`,params).then(res => res); };
///查询有机知识信息分页
export const getYoujizhishiListView = params => { return http.get (`/Api/Youjizhishi/GetListView`,params).then(res => res); };



// WEBPACK FOOTER //
// ./src/api/api.js